import { ActionReducerMap } from '@ngrx/store';
import { routerReducer } from '@ngrx/router-store';
import { IAppState } from './app.state';
import { serviciosReducers } from './reducers/servicios.reducers';
import { centrosReducers } from './reducers/centros.reducers';
import { empleosReducers } from './reducers/empleos.reducers';
import { personasReducers } from './reducers/personas.reducers';
import { gruposReducers } from './reducers/grupos.reducers';
import { beneficiariosReducers } from './reducers/beneficiarios.reducers';
import { AuthReducers } from './reducers/auth.reducers';
import { programasReducers } from './reducers/programas.reducers';
import { institucionesReducers } from './reducers/instituciones.reducers';
import { formulariosReducers } from './reducers/formularios.reducers';


export const appReducers: ActionReducerMap<IAppState, any> = {
    router: routerReducer,
    servicios: serviciosReducers,
    centros: centrosReducers,
    empleos: empleosReducers,
    personas: personasReducers,
    grupos: gruposReducers,
    beneficiarios: beneficiariosReducers,
    programas: programasReducers,
    instituciones: institucionesReducers,
    auth: AuthReducers,
    formularios: formulariosReducers,
};
